export const classes = {
  iconButton:
    'text-grey-6 dark:text-mauve-3 hover:text-grey-8 dark:hover:text-mauve-1',
  icon: 'text-taupe-2 dark:text-mauve-2',
};
